interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  /** `sm` for a toolbar, `md` beside a settings row. */
  size?: 'sm' | 'md';
  /** Name it with one of these: the visible label's id, or text. */
  'aria-labelledby'?: string;
  'aria-label'?: string;
  'aria-describedby'?: string;
}

const SIZES = {
  sm: { track: 'h-5 w-9', knob: 'h-4 w-4', on: 'translate-x-4' },
  md: { track: 'h-6 w-11', knob: 'h-5 w-5', on: 'translate-x-5' },
};

/** An on/off setting that takes effect as it is flipped. */
export default function Switch({ checked, onChange, disabled, size = 'md', ...aria }: SwitchProps) {
  const s = SIZES[size];
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      {...aria}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex ${s.track} flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60 ${
        checked ? 'bg-blue-600' : 'bg-gray-300'
      }`}
    >
      <span
        aria-hidden
        className={`pointer-events-none inline-block ${s.knob} rounded-full bg-white shadow transition-transform duration-200 motion-reduce:transition-none ${
          checked ? s.on : 'translate-x-0'
        }`}
      />
    </button>
  );
}
